import battery from '../../Assets/Images/battery.svg';
import './TotalEV.scss';
import { numberFormat } from '../../utils/Helper';
import { Count } from '../../utils/Helper';
import Indian_Flag from '../../Assets/Images/Indian_Flag.png';
const EVCountData={"fourWheeler":155207,"twoWheeler":2083106,"date":"2022-09-05 01:00:21.697386"}

const TotalEV = () => {
  return (
    <>
      <section className='' id="Home">
        <div className='TotalEV-Card'>
          <div className='TotalEv-Wrap'>
            <img src={Indian_Flag} style={{ height: '1.8rem' }} alt='' />
            <span className='Total-text'>Total EV Sales in India</span>
          </div>
          <div className='sales'>
            {/* <h1>{numberFormat(PermiumDetailsSummary(250000))}</h1> 2022-08-29 01:00:22.456437 */}
            <Count label={'wer'} number={EVCountData.twoWheeler} duration={1000} style={{}} />
            <Count label={'wer'} number={EVCountData.fourWheeler} duration={1000} style={{}} />
          </div>

          <div className='sales'>
            <p className='wheeler'>Two-Wheelers</p>
            <p className='wheeler'>Four-Wheelers</p>
          </div>

          <div className='te-source'>Source : vahan.parivahan.gov.in</div>
        </div>
      </section>
    </>
  );
};

export default TotalEV;
